import { CommonDataAndUtil } from "../../CommonDataAndUtil";
import { CartItems ,CartItem} from "./DataType";

export class CartDatabase{
    private isUserLogin:boolean;
    private url:any;
    constructor(){
        this.url={
            getItems:'/cart/get_items',
            addItem:'/cart/add_item',
            updateItem:'/cart/updateitem',
            removeItems:'/cart/remove_items',
            modifyNum:'/cart/modify_num',
            checkItem:'/cart/checkitem',
            empty:'/cart/removeall'
        };
    }
    getItems(){
        let items=[];
        $.ajax({
            type: "get",
            async: false,
            url:this.url.getItems,
                       
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            cache: false,
            success: function (r) {
                if(CommonDataAndUtil.isSuccess(r)){
                    items=r.data;
                }
            }
        });
        return items;
    }
    
    


    addItem(item:CartItem,items:CartItems){
       // $.post(this.url.addItem,{item:item});
        return this.syncAjax(this.url.addItem,{item:item});
    }
    modifyNum(itemId,num,items:CartItems){
        return this.syncAjax(this.url.modifyNum,{item_id:itemId,num:num});
    }
    updateItem(item:CartItem,items:CartItems){
        return this.syncAjax(this.url.updateItem,{item:item});
        
    }
    removeItems(itemIds:Array<string>,items:CartItems){
        return this.syncAjax(this.url.removeItems,{item_ids:itemIds});
    }
    /**
 * 
 * @param itemIds 
 * @param mode check,uncheck,checkall,uncheckall
 * @param items
 */
    checkItem(itemId,mode="check",items:CartItems){
        return this.syncAjax(this.url.checkItem,{item_id:itemId,mode:mode});
    }
    empty(){
        return this.syncAjax(this.url.empty);
    }

    private syncAjax(url,data={}){
        let ret={status:CommonDataAndUtil.STATUS_FAILED,info:'操作失败'};
        $.ajax({
            type: "POST",
            async: false,
            url:url,
            data:data,   
          //  contentType: "application/json; charset=utf-8",
            dataType: "json",
            cache: false,
            success: function (r) {
                ret=r;                 
            }
        });
        return ret;
    }
}